import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Typography, Button, Box } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    caseTitle: {
        marginTop: theme.spacing(3),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(2),
        fontWeight: '400',
    },
    caseNumber: {
        color: theme.palette.primary.main,
        marginLeft: theme.spacing(1),
    },
    caseTitleBox: {
        display: 'flex',
        marginBottom: theme.spacing(1),
    },
    headerButtons: {
        display: 'flex',
        marginLeft: 'auto',
    },
}))

export const ContentTitle = ({
    pageTitle,
    caseId,
    actionButtonText,
    onActionButtonClick,
}) => {
    const classes = useStyles()
    return (
        <Grid item xs={12}>
            <Box className={classes.caseTitleBox}>
                <Typography
                    variant='h1'
                    className={classes.caseTitle}
                    color='inherit'>
                    {caseId ? 'Case' : null}
                    <span className={classes.caseNumber}>
                        {caseId} {pageTitle}
                    </span>
                </Typography>
                <Box className={classes.headerButtons}>
                    {onActionButtonClick && (
                        <Box display='flex' alignItems='center' mr={1}>
                            <Button
                                variant='contained'
                                color='secondary'
                                className={classes.actionButton}
                                onClick={onActionButtonClick}>
                                {actionButtonText}
                            </Button>
                        </Box>
                    )}
                </Box>
            </Box>
        </Grid>
    )
}
